document.addEventListener('DOMContentLoaded', () => {
  for (const section of document.querySelectorAll('[data-box-contents]')) {
    const track = section.querySelector('[data-box-contents-track]');
    const progress = section.querySelector('[data-box-contents-progress]');
    if (!track || !progress) continue;

    // The bar fills to the right edge of what is on screen, so it starts part-filled and reaches 100% at the end
    const updateProgress = () => {
      const { scrollLeft, clientWidth, scrollWidth } = track;
      progress.value = scrollWidth > 0 ? Math.min(100, ((scrollLeft + clientWidth) / scrollWidth) * 100) : 100;
    };

    let frame = null;
    const scheduleUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        updateProgress();
      });
    };

    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    // The stylesheet loads lazily, so the track only becomes a scrolling row after this first run; re-measure once it lays out
    window.addEventListener('load', scheduleUpdate, { once: true });
    new ResizeObserver(scheduleUpdate).observe(track);
    updateProgress();
  }
});
